import React, { useState, useEffect } from 'react';
import { set } from 'zod';
import useOutsideClick from '~/hooks/outside-click';
import countries from '~/data/sidebar/countries.json';
import { use } from 'marked';

const PhoneCodes = ({ setPhoneCode }) => {
  const [activeCountry, setActiveCountry] = useState('US');
  const [showCountries, setShowCountries] = useState(false);
  const wrapperRef = React.useRef(null);

  const handleCountry = (sortname, phoneCode) => {
    setPhoneCode(phoneCode);
    setActiveCountry(sortname);
    setShowCountries(false);
  };

  const showCountryList = () => {
    setShowCountries(true);
  };

  const hideCountryList = () => {
    setShowCountries(false);
  };

  useOutsideClick(wrapperRef, hideCountryList);

  return (
    <>
      <button
        type='button'
        className='selected-country'
        onClick={showCountryList}
      >
        <img
          className='flag'
          src={'/flags/' + activeCountry + '.svg'}
        />
      </button>
      <ul
        className={`flags-wr ${showCountries ? '' : 'is-hidden'}`}
        onBlur={hideCountryList}
        tabIndex={0}
        ref={wrapperRef}
      >
        {countries.list.map((country, index) => {
          return (
            <li
              key={index}
              data-id={country.sortname}
              className='cursor-pointer'
              onClick={() =>
                handleCountry(country.sortname, country.phone_code)
              }
            >
              <img
                className='flag'
                src={'/flags/' + country.sortname + '.svg'}
                alt={country.name}
                loading='eager'
              />
              <span className='country'>
                {country.name} (+{country.phone_code})
              </span>
            </li>
          );
        })}
      </ul>
    </>
  );
};

export default PhoneCodes;
